import { Group, Text, Tooltip } from '@mantine/core'
import { IconCircleFilled } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'

type OnlineStatusProps = {
  status: 'online' | 'offline'
  withText?: boolean
}

export const OnlineStatus = ({
  status,
  withText = true
}: OnlineStatusProps) => {
  return (
    <Tooltip
      disabled={withText}
      label={
        <FormattedMessage
          id={
            status === 'online'
              ? 'devices.status.online'
              : 'devices.status.offline'
          }
        />
      }
    >
      <Group wrap="nowrap" gap={4} align="center">
        <IconCircleFilled
          size={9}
          color={
            status === 'online'
              ? 'var(--mantine-color-green-6)'
              : 'var(--mantine-color-red-6)'
          }
        />

        {withText && (
          <Text size="xs">
            <FormattedMessage
              id={
                status === 'online'
                  ? 'devices.status.online'
                  : 'devices.status.offline'
              }
            />
          </Text>
        )}
      </Group>
    </Tooltip>
  )
}
